import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-8 text-center px-4" data-id="element-58">
      <p className="text-sm" data-id="element-59">
        © {new Date().getFullYear()} Arquitectura del Freezer™. Todos los
        derechos reservados.
      </p>
    </footer>;
}